import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { EventsEventsFormCreate } from '../../../features/user/expert/Events-events/EventsEventsContainer';

export const CreateEvents: React.FC = () => {
  return <EventsEventsFormCreate />;
};
